import React from 'react';

import styles from './component.module.scss';

const StatsGroup = ({
  title,
  children
}: {
  title?: string;
  children: React.ReactNode;
}) => {
  return (
    <div className={styles.main}>
      {title && <h4>{title}</h4>}
      <div className={styles.stats}>{children}</div>
    </div>
  );
};

export { StatsGroup };
